import {
    AnalyticsEventTypes,
    AnalyticsProtoEvents,
} from '@src/app/utils/analyticsScreenNames';
import {
    onUnmounted,
    ref,
    watch,
} from '@vue/composition-api';
import Vue from 'vue';
import { Analytics as AnalyticsSDK } from '@superbet-group/web.analytics.sdk';

export function useSendSectionViewportVisibilityAnalyticsEvent(sectionName: string, threshold = 0.5) {
    const observerRef = ref<HTMLDivElement>();

    const observer = new IntersectionObserver(
        (entries) => {
            if (entries[0].isIntersecting) {
                // @TODO(corneliu-iancu): Temporary dual analytics implementation.
                // We are currently in the process of migrating from $superAnalytics to AnalyticsSDK.
                // Both libraries are being used in parallel to validate data consistency between them.
                // DO NOT modify or remove calls to $superAnalytics until the migration is fully validated and approved.
                // Once validation is complete, $superAnalytics will be deprecated and removed.
                AnalyticsSDK.getInstance().log('section_viewport_visibility', { section_name: sectionName });
                Vue.prototype.$superAnalytics.sendEvent({
                    eventType: AnalyticsEventTypes.sectionViewportVisibility,
                    sectionViewportVisibility: {
                        sectionName,
                    },
                    AnalyticsEvent: AnalyticsProtoEvents.sectionViewportVisibility,
                });

                observer.disconnect();
            }
        },
        { threshold },
    );

    watch(() => observerRef.value, (value) => {
        if (value) {
            observer.observe(value);
        }
    });

    onUnmounted(() => {
        observer?.disconnect();
    });

    return {
        observerRef,
    };
}
